import { Icon } from "@iconify/react";
import React, { useMemo, useRef } from "react";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import PropTypes from "prop-types";
/**
 * Este componente renderiza los botones de los filtros que actualmente están activos, también realiza la lógica para actualizar los filtros actuales y removerlos desde los botones.
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.filterAndSearchManager - Referencia al hook useFilterAndSearchManager para gestionar los filtros.
 * @returns {JSX.Element}
 */
export const FilterCardsContainer = ({ filterAndSearchManager = {} }) => {
	const { textosSubSecciones: textos } = useObtenerSubsecciones("busqueda");
	const filters = filterAndSearchManager?.filters;
	const activeFilters = filterAndSearchManager.getActiveFilters(filters);
	const previousFilters = useRef([]);
	const isLoadingFilters = filterAndSearchManager.loading;
	const formattedFilters = useMemo(() => {
		const filters = [];
		activeFilters.forEach((filter) => {
			if ((filter.displayType === "multicheckbox" || filter.paramKey === "tag") && Array.isArray(filter.items)) {
				filter.items.forEach((item) => {
					if (item.active) {
						filters.push({ ...item, parentKey: filter.paramKey });
					}
				});
			} else {
        if(filter.displayType !== 'sort-dropdown'){
          filters.push(filter);
        }
			}
		});

		if (isLoadingFilters) {
			previousFilters.current = filters;
		}

		return !isLoadingFilters ? previousFilters.current : filters;
	}, [activeFilters, isLoadingFilters]);

	const handleDeleteFilter = (filter) => {
		if (filter.parentKey) {
			filterAndSearchManager.updateFilters((draft) => {
				const parent = draft[filter.parentKey];
				if (parent) {
					parent.items = parent.items.map((item) => {
						if (item.paramValue === filter.paramValue) {
							item.active = false;
						}
						return item;
					});
				}
			});
		} else {
			filterAndSearchManager.updateFilters((draft) => {
				const _current = draft[filter.paramKey];
				if (_current) {
					_current.active = false;
					if (filter.paramKey === "sch") {
						draft.sch.paramValue = "";
					}
				}
			});
		}
		filterAndSearchManager.forceSearch();
	};


	return (
		<div
			tabIndex={0}
			className={"focusable-secondary"}
			role={"region"}
			aria-label={textos?.filtro?.filtros_aplicados?.titulo || `Filtros aplicados`}
		>
			{formattedFilters.length > 0 && (
				<h3 tabIndex={0} className="focusable-secondary blue-dark--color">
					{textos?.filtro?.filtros_aplicados?.titulo || `Filtros aplicados`}
				</h3>
			)}
			<div className={`d-flex flex-row flex-wrap ${formattedFilters.length > 0 ? 'my-3' : ''}`}>
				{formattedFilters.map((filter, i) => {
					const name = filter?.parentKey
						? `${
								textos?.filtro?.categorias?.[filter?.displayLabel?.translationId] ||
								filter?.displayLabel?.default
						  }`
						: `${
								textos?.filtro?.nombre_filtro?.[
									filter?.displayLabel?.translationId
								] || filter?.displayLabel?.default
						  }`;
					return (
						<div className="" key={i}>
							<FilterCard
								name={name}
								data={filter}
								onDeleteCard={(filterData) => {
									handleDeleteFilter(filterData);
								}}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

//=================================================================================================


  /**
 * Este componente renderiza un botón el cual hace referencia a un filtro aplicado
 */
  const FilterCard = ({ name, data, onDeleteCard }) => {
    return (<div className="current-filter-removable-button" aria-label={name} role={"region"}>
      <p>{name}</p>
      <button className="focusable-secondary" onClick={() => onDeleteCard(data)}>
      <Icon icon="ic:round-close" />
      </button>
    </div>)
  }
  
  FilterCard.propTypes = {
    /**
     * nombre que llevará el botón
     */
    name:PropTypes.string.isRequired,
    /**
     * objet con la información del filtro
     */
    data:PropTypes.object.isRequired,
    /**
     * función que se ejecuta cuando se da click en cerrar el botón
     */
    onDeleteCard:PropTypes.func,
  }

  
  